<template>
  <el-dialog
    title="上传头像"
    width="500px"
    :close-on-click-modal="false"
    :visible.sync="visible"
    :before-close="handleClose">
    <div class="batch-match-wrap">
      <slot class="import-tips" name="import-tips"></slot>
      <div class="import-dialog-container">
        <p style="color:#4B380E;font-weight:bold;margin-right:10px;">选择图片文件：</p>
        <div class="button-input-file-wrapper">
          <el-button
            type="primary"
            class="button-input-file">
            {{ fileName }}
          </el-button>
          <input type="file" ref="fileInput" class="file-input" @change="handleChange">
        </div>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button type="success" :disabled="submitDiabled" @click="submitUpload" :loading="submitLoading">上 传</el-button>
      <el-button type="info" @click="cancelDialog">取 消</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { importUserPhoto } from '@/model/info-model'
import common from '@/util/common'

export default {
  name: 'ImportClass',
  props: {
    visible: {
      type: Boolean,
      default: true
    },
    userInfo: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      submitLoading: false,
      file: {},
      fileName: '点击选择文件',
      submitDiabled: true
    }
  },
  methods: {
    checkFile (file) {
      // 必须要是 excel 文件
      let isExcelFile = /\.jpg|\.gif|\.png?$/.test(file.name)
      // 必须小于等于 10M
      let isLessThen5M = file.size / 1024 / 1024 <= 10

      if (!isExcelFile) {
        this.$message({
          type: 'warning',
          message: '上传文件只能是jpg格式（或gif格式，png格式）',
          duration: 5000
        })
      } else {
        if (!isLessThen5M) {
          this.$message({
            type: 'warning',
            message: '上传文件大小不能超过10M',
            duration: 5000
          })
        }
      }
      return isExcelFile && isLessThen5M
    },
    initData () {
      this.submitLoading = false
      this.file = {}
      this.fileName = '点击选择文件'
      this.submitDiabled = true
    },
    /**
     * 导入错误提示(该方法后期要封装)
     * @author wangk 2018-04-18T17:04:51+0800
     * @param  {String} link 错误文档链接
     * @return {[type]}      [description]
     */
    alertImportError (errorMsgs, errorFileLink) {
      const h = this.$createElement
      let tipEls = [
        h('div', {
          'class': ['kw-alert__icon', `kw-alert__icon--warning`]
        }, '')
      ]
      errorMsgs.forEach(val => {
        tipEls.push(h('p', {
          'class': ['kw-alert__tips', 'kw-alert__tips--warning']
        }, val))
      })
      if (errorFileLink) {
        tipEls.push(
          h('a', {
            attrs: {
              href: errorFileLink,
              target: '_blank'
            },
            style: {
              color: '#FF6501',
              outline: 'none'
            }
          }, '下载问题文档')
        )
      }
      let vnode = h('div', {
        'class': ['kw-alert__wrapper']
      }, tipEls)
      this.$alert(vnode, '', {
        confirmButtonText: '我知道了',
        center: true,
        showClose: false,
        showCancelButton: false,
        confirmButtonClass: 'kw-alert__confirm-button kw-alert__confirm-button--success'
      })
    },
    // 该方法后期要封装
    alertImportSuccess (msg) {
      const h = this.$createElement
      let vnode = h('div', {
        'class': ['kw-alert__wrapper']
      }, [
        h('div', {
          'class': ['kw-alert__icon', `kw-alert__icon--success`]
        }, ''),
        h('p', {
          'class': ['kw-alert__tips', 'kw-alert__tips--success']
        }, msg)
      ])
      this.$alert(vnode, '', {
        confirmButtonText: '我知道了',
        center: true,
        showClose: false,
        showCancelButton: false,
        callback: action => {
          this.cancelDialog()
          this.$emit('upload-success')
          // common.goHome()
        }
      })
    },
    handleChange () {
      let file = this.$refs.fileInput.files[0]
      if (file) {
        this.file = file
        this.fileName = file.name
        if (this.checkFile(file)) {
          this.submitDiabled = false
        } else {
          this.submitDiabled = true
        }
      }
    },
    submitUpload () {
      if (typeof this.file.name === 'undefined') {
        this.alertImportError('文件为空', null)
        return
      }
      this.submitLoading = true
      let formData = new FormData()
      formData.append('file', this.file)
      importUserPhoto({
        file: formData,
        data: {
          userId: this.userInfo.userId
        }
      }).then(res => {
        this.submitLoading = false
        if (res.result === 'true') {
          // 导入成功
          this.alertImportSuccess(`用户头像上传成功`)
        } else {
          this.alertImportError([res.errDesc], null)
        }
      }).catch(e => {
        this.submitLoading = false
        this.alertImportError(['用户头像上传失败，请稍后重试'], null)
      })
    },
    cancelDialog () {
      this.$emit('upload-photo-close', false)
      // common.goHome()
    },
    handleClose (done) {
      // 不调用 done, 而应该让父组件去关闭弹窗
      this.$emit('upload-photo-close', false)
      // common.goHome()
    }
  }
}
</script>
<style lang="scss" scoped>
.batch-match-wrap{
  margin: 0 42px;
}

.import-tips {
  margin: 0 auto;
  width: 580px;
  color: #459146;
  padding-left: 30px;
  background: url("~@/assets/image/bell.png") left center no-repeat;
}
.import-dialog-container {
  box-sizing: border-box;
  padding: 45px 0;
  margin: 0 auto;
  display: flex;
  align-items: center;

  .button-input-file-wrapper {
    position: relative;
  }

  .button-input-file {
    background: transparent;
    width: 220px;
    height: 30px;
    padding: 0;
    color: #A78C6F;
    overflow: hidden;
    text-overflow: ellipsis;
    position: relative;
  }

  .file-input {
    position: absolute;
    top: 0;
    left: 0;
    width: 220px;
    height: 30px;
    // visibility: hidden;
    color:transparent;
    border: none;
    background: transparent;
    opacity: 0;
    z-index: 10;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/user/ImportUserPhoto.vue